import { isNotUndefined } from 'typesafe-utils';

export const isDev = process.env.NODE_ENV === 'development' || isNotUndefined(process.env.VERCEL);
